import {passwordContainsNumber, passwordLength, passwordUppercaseAndLowerCase} from './passwordValidations';
import {hasAtLeastOneLetter} from './userCredentials';

export const passwordValidations = [
    {
        validationMethod: passwordLength,
        text: 'Use 8 or more characters',
        valid: false,
    },
    {
        validationMethod: passwordUppercaseAndLowerCase,
        text: 'Use upper and lower case letters',
        valid: false,
    },
    {
        validationMethod: passwordContainsNumber,
        text: 'Use a number',
        valid: false,
    },
];

export const userCredentialsValidations = {
    firstName: [
        {
            validationMethod: hasAtLeastOneLetter,
            text: 'First name must contain at least 1 letter!',
        },
    ],
    lastName: [
        {
            validationMethod: hasAtLeastOneLetter,
            text: 'Last name must contain at least 1 letter!',
        },
    ],
};

export const userInterestsOptions = [
    {text: 'Buying a home', checked: true, disabled: false},
    {text: 'Getting a mortage', checked: false, disabled: false},
    {text: 'Selling a home', checked: false, disabled: false},
    {text: 'Not sure yet', checked: false, disabled: false},
];


export default {
    serverError: {
        title: 'Something went wrong!',
        message: 'Something went wrong on our side. Please contact support!',
    },
    wrongPassword: {
        title: '',
        message: 'Incorrect password. Please try again.',
    },
    invalidEmail: {
        title: '',
        message: 'We can\'t find this email address. Please try again.',
    },
    invalidPasswordRecoveryUrl: {
        title: '',
        message: 'Invalid Password Recovery Url',
    },
    invalidPassword: {
        title: '',
        message: 'Invalid Password',
    },
};
